import { providerConfig } from '../config/providers'
import type { Coordinates, RouteInfo } from '../types'
import { RouteProviderError, type RouteProvider } from './RouteProvider'

interface RouteApiResponse extends Partial<RouteInfo> {
  message?: string
}

export class GoogleRoutesProvider implements RouteProvider {
  readonly name = 'GoogleRoutesProvider'

  async getRoute(origin: Coordinates, destination: Coordinates): Promise<RouteInfo> {
    let response: Response
    try {
      response = await fetch(providerConfig.routes.endpoint, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ origin, destination }),
      })
    } catch {
      throw new RouteProviderError('경로 정보를 불러오려면 API 설정이 필요합니다.')
    }

    const data = await response.json().catch(() => ({})) as RouteApiResponse
    if (!response.ok || typeof data.distanceMeters !== 'number' || typeof data.durationSeconds !== 'number') {
      throw new RouteProviderError(data.message ?? '경로 정보를 불러오려면 API 설정이 필요합니다.')
    }
    return { distanceMeters: data.distanceMeters, durationSeconds: data.durationSeconds }
  }
}
